<script setup>
import { router, usePage } from '@inertiajs/vue3';
import { computed, onUnmounted } from 'vue';
import { useOverlay } from '@/composables/useOverlay';

const { overlays, unMount, close, closeAll } = useOverlay();

const mountedOverlays = computed(() => overlays.filter((overlay) => overlay.isMounted));

const page = usePage();
let previousComponent = page.component;

onUnmounted(
    router.on('navigate', (event) => {
        const nextComponent = event.detail.page.component;

        if (nextComponent !== previousComponent) {
            closeAll();
        }

        previousComponent = nextComponent;
    }),
);

const onAfterLeave = (id) => {
    close(id);
    unMount(id);
};

const onClose = (id, value) => {
    close(id, value);
};
</script>

<template>
    <component
        :is="overlay.component"
        v-for="overlay in mountedOverlays"
        :key="overlay.id"
        v-bind="overlay.props"
        v-model:open="overlay.isOpen"
        @close="(value) => onClose(overlay.id, value)"
        @after:leave="onAfterLeave(overlay.id)"
    />
</template>
